// The Worker's error() helper (itty-router) returns a JSON body
// ({ status, error }), not plain text — res.text() on it surfaces the raw
// JSON blob (e.g. '{"status":403,"error":"Forbidden"}') directly in a toast
// instead of a message. Parse it properly and fall back to a contextual PT
// message when the body can't be parsed or carries no error field.
export async function extractErrorMessage(res: Response, fallback: string): Promise<string> {
  const body = await res.json().catch(() => null) as { error?: string } | null
  return body?.error || fallback
}
